export class GoogleData {
  calendars: GoogleCalendar[] = [];

  constructor(json?: any) {
    if (json) {
      this.calendars = json?.calendars.map(v => new GoogleCalendar(v));
    }
  }
}

export class GoogleCalendar {
  name: string;
  events: GoogleEvent[] = [];

  constructor(json?: any) {
    if (json) {
      this.name = json.name;
      this.events = json?.events.map(v => new GoogleEvent(v));
    }
  }
}

export class GoogleEvent {
  text: string;
  startDate: Date;
  endDate: Date;

  constructor(json?: any) {
    if (json) {
      this.text = json.text;
      this.startDate = new Date(json.startDate);
      this.endDate = new Date(json.endDate);
    }
  }
}

/**
 * Vue « qui est de piquet » pour un calendrier : celui ou ceux en service
 * aujourd'hui, puis les relèves à venir. Le backend expose les deux moitiés
 * séparément (/today et /following) ; le regroupement se fait ici.
 */
export class DutyCalendar {
  constructor(
    public name: string,
    public current: GoogleEvent[],
    public next: GoogleEvent[]
  ) {
  }
}

/**
 * Recoud les deux réponses par nom de calendrier. La liste est pilotée par
 * `today`, qui porte tous les calendriers configurés — y compris ceux sans
 * piquet aujourd'hui, dont c'est le seul moyen de connaître le nom.
 */
export function toDutyCalendars(today: GoogleData, following: GoogleData, nextCount: number): DutyCalendar[] {
  return (today?.calendars ?? []).map(cal => {
    const upcoming = following?.calendars?.find(c => c.name === cal.name);
    return new DutyCalendar(cal.name, cal.events ?? [], (upcoming?.events ?? []).slice(0, nextCount));
  });
}
